export class PartnerGroups {
    static moduleName = 'partnerGroups';
    static moduleEntityName = 'partnerGroupsEntity';
    static listTitle = 'Список групп партнерских предложений';
    static createTitle = 'Добавление новой группы партнерских предложений';
    static editTitle = 'Редактирование группы партнерских предложений';
    static apiPrefix = 'partner-groups';
}